import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from '@core/store'
import { router } from './Router'

const App = () => {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  )
}

export default App
